import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLightbulb,
  faAward,
  faUsers,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const companyValues = [
  {
    title: "faq.innovation",
    description: "faq.innovationDescription",
    icon: faLightbulb,
  },
  {
    title: "faq.quality",
    description: "faq.qualityDescription",
    icon: faAward,
  },
  {
    title: "faq.customerCentric",
    description: "faq.customerCentricDescription",
    icon: faUsers,
  },
  {
    title: "faq.integrity",
    description: "faq.integrityDescription",
    icon: faHandshake,
  },
];

const companyStats = [
  { label: "faq.yearsInBusiness", value: 10 },
  { label: "faq.clientsServed", value: 500 },
  { label: "faq.teamMembers", value: 50 },
  { label: "faq.countriesReached", value: 30 },
];

export default function AboutUs() {
  const { t } = useTranslation();

  return (
    <div className="dark:bg-black w-full flex flex-col items-center mx-auto py-12 pt-24 lg:py-24 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="mt-12 dark:text-white text-3xl font-bold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
            {t("aboutUs.title")}
          </h1>
          <p className="dark:text-zinc-400 mt-4 text-base leading-7 text-gray-600">
            {t("aboutUs.description")}
          </p>
        </div>

        <h2 className="dark:text-white text-3xl font-semibold text-center text-gray-900 mb-8">
        {t("aboutUs.historyTitle")}
        </h2>
        <div className="dark:text-zinc-400 w-11/12 mx-auto mb-12">
          <p className="text-lg mb-4">{t("aboutUs.historyPart1")}</p>
          <p className="text-lg mb-4">{t("aboutUs.historyPart2")}</p>
        </div>

        <div className="mb-16">
          <h2 className="dark:text-white text-3xl font-bold text-center text-gray-900 mb-12">
            {t("aboutUs.valuesTitle")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {companyValues.map((value, index) => (
              <div
                key={index}
                className="dark:border-none dark:bg-slate-900 relative p-8 bg-white border border-gray-200 rounded-xl shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl flex flex-col items-center"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="relative flex items-center justify-center bg-[#00A8E8] p-4 rounded-full shadow-lg mb-4">
                  <div className="absolute inset-0 rounded-full bg-[#00A8E8] opacity-30 blur-md"></div>
                  <div className="relative z-10">
                    <FontAwesomeIcon icon={value.icon} className="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold dark:text-white text-gray-900 text-center">
                  {t(value.title)}
                </h3>
                <p className="mt-2 text-base dark:text-zinc-400 text-gray-600 text-center">
                  {t(value.description)}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Section */}
        <div className="mb-16">
          <h2 className="dark:text-white text-3xl font-bold text-center text-gray-900 mb-12">
            {t("aboutUs.impactTitle")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {companyStats.map((stat, index) => (
              <div
                key={index}
                className="dark:border-none dark:bg-slate-900 relative p-8 bg-white border border-gray-200 rounded-xl shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <h3 className="dark:text-white text-4xl font-bold mb-2">
                  {stat.value}+
                </h3>
                <p className="dark:text-zinc-400 text-gray-600">{t(stat.label)}</p>
                <div className="w-full bg-gray-200 rounded-full h-2.5 mt-4">
                  <div className="bg-[#00A8E8] h-2.5 rounded-full w-3/4"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mission Section */}
        <div className="mb-16">
          <h2 className="dark:text-white text-3xl font-bold text-center text-gray-900 mb-12">
            {t("aboutUs.missionTitle")}
          </h2>
          <div
            className="dark:border-none dark:bg-slate-900 relative p-8 bg-white border border-gray-200 rounded-xl shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <p className="dark:text-zinc-400 text-lg italic text-center">
              &quot;{t("aboutUs.mission")}&quot;
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
